import * as React from 'react';
import { useEffect, useState } from 'react';
// import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import Helper from 'src/support/Helper';

export function QuoteInformationCheckout(props) {
    // const [{ quoteRequestedDate, quoteExpirationDate }, { fetch_quote_header_detail }, { }] = useQuoteDetailStore(); // Eleminate quote Header call
    const { quoteNumber } = props;
    const [quoteDetail, setQuoteDetail] = useState({});
    const storageQuoteDetail = sessionStorage.getItem("quoteHeader");

    // useEffect(() => {
    //     async function fetchHere() {
    //         fetchAPICall()
    //     }
    //     fetchHere();
    // }, []);

    useEffect(() => {
        if (storageQuoteDetail)
            setQuoteDetail(JSON.parse(storageQuoteDetail));
    }, [storageQuoteDetail]);

    // const fetchAPICall = async () => {
    //     await fetch_quote_header_detail(quoteNumber);
    // };

    return (
        <div className="qoute-information mb-3">
            <div className="qoute-information-title">quote information</div>
            <div className="row">
                <div className="col-md-4">
                    <div className="qoute-label"> Quote Number </div>
                    <div className="qoute-value"> {quoteNumber} </div>
                </div>
                <div className="col-md-4">
                    <div className="qoute-label"> Created On </div>
                    {/* <div className="qoute-value">{quoteRequestedDate && Helper.dateFormatFromString(quoteRequestedDate)}</div> */}
                    <div className="qoute-value">{quoteDetail.quoteRequestedDate && Helper.dateFormatFromString(quoteDetail.quoteRequestedDate)}</div>
                </div>
                <div className="col-md-4">
                    <div className="qoute-label"> Expires On </div>
                    {/* <div className="qoute-value">{quoteExpirationDate && Helper.dateFormatFromString(quoteExpirationDate)}</div> */}
                    <div className="qoute-value">{quoteDetail.quoteExpirationDate && Helper.dateFormatFromString(quoteDetail.quoteExpirationDate)}</div>
                </div>
            </div>
        </div>
    );

}
export default QuoteInformationCheckout;
